// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + {"vendors-node_modules_atlas_ui_build_styles_css":"c03e223f3a08e0aa8fc9","src_modules_share-css_js":"bb433ccef41a30a8bcfa"}[chunkId] + "/index.css";
};